document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.moveItemButton').addEventListener('mouseup', function () {
    clearInterval(intervalId);
  });

  document.querySelector('.moveItemButton').addEventListener('mouseleave', function () {
    clearInterval(intervalId);
  });
});


async function updateProperties() {
  app.updateLayers();

  let sel = app.getSelectedNode();

  //console.log("updateProperties", sel.getClassName());
  let propEls = {
    "positionInputs": true,
    "textString": false,
    "align": false,
    "fontStyle": false,
    "fontSize": false,
    "fontFamily": false,
    "letterSpacing": false,
    "lineHeightInput": false,
    "textDirection": false,
    "arcAngleInput": false,
    "scaleInput": false,
    "rotationInput": false,
    "wavesInput": false,
    "waveWidthInput": false,
    "waveHeightInput": false,
    "radiusInput": false,
    "radiusInputX": false,
    "radiusInputY": false,
    "outerRadius": false,
    "innerRadius": false,
    "sidesInput": false,
    "rectangleWidth": false,
    "rectangleHeight": false,
    "rectangleRadius": false,
    "pointsInput": false,
    "width": false,
    "height": false,
    "strokeWidth": false,
    "filledInput": false,
    "pointerWidthInput": false,
    "pointerLengthInput": false,
    "startRadiusInput": false,
    "endRadiusInput": false,
    "revolutionsInput": false,
    "pegSizeSelect": false,

    "sizeInput": false,
    "turnsInput": false,
    "spacingInput": false,
    "thicknessInput": false,
  };

  if (sel) {
    let textString = "";
    let align = "";
    let fontFamily = "";
    let fontStyle = "";
    let fontSize = 0;
    let letterSpacing = 0;
    let lineHeight = 0;
    let angle = 0;
    let direction = "";
    let waves = 1;
    let waveWidth = 1;
    let waveHeight = 1;
    let radius = 0;
    let radiusX = 0;
    let radiusY = 0;
    let outerRadius = 0;
    let innerRadius = 0;
    let sides = 0;
    let points = 0;
    let strokeWidth = 0;
    let filled = false;
    let pointerWidthInput = 0;
    let pointerLengthInput = 0;
    let pegSizeSelect = "";
    let startRadiusInput = 0;
    let endRadiusInput = 0;
    let revolutionsInput = 0;
    let sizeInput = 0;
    let turnsInput = 0;
    let spacingInput = 0;
    let thicknessInput = 0;

    let enabledProps = [];
    let propVals = {};


    if (sel.getClassName && sel.getClassName() && (sel.attrs.type === "baseImage")) {
      propEls.positionInputs = false;
    }

    if (sel.getClassName && sel.getClassName() === "Text") {
      enabledProps = [
        "textString",
        "align",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "textDirection",
      ];
    } else if (sel.getClassName() === "SinewaveTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "wavesInput",
        "waveWidthInput",
        "waveHeightInput",
      ];
    } else if (sel.getClassName() === "BezierTextPathGroup") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
      ];
    } else if (sel.getClassName() === "QuadraticTextPathGroup") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
      ];
    } else if (sel.getClassName() === "CircleTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "radiusInput",
      ];
    } else if (sel.getClassName() === "EllipseTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "radiusInputX",
        "radiusInputY",
      ];
    } else if (sel.getClassName() === "RectangleTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "rectangleWidth",
        "rectangleHeight",
        "rectangleRadius",
      ];
    } else if (sel.getClassName() === "SidedTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "radiusInput",
        "sidesInput",
      ];
    } else if (sel.getClassName() === "HeartTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "width",
        "height",
      ];
    } else if (sel.getClassName() === "StarTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "width",
        "height",
        "radiusInput",
        "pointsInput",
      ];
    } else if (sel.getClassName() === "TeardropTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "width",
        "height",
      ];
    } else if (sel.getClassName() === "SpiralTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "startRadiusInput",
        "endRadiusInput",
        "revolutionsInput",
      ];
    } else if (sel.getClassName() === "SquareSpiralTextPath") {
      enabledProps = [
        "textString",
        "fontStyle",
        "fontSize",
        "fontFamily",
        "letterSpacing",
        "sizeInput",
        "turnsInput",
        "spacingInput",
        //"thicknessInput",
      ];
    } else if (sel.getClassName() === "Rect") {
      enabledProps = [
        "width",
        "height",
        "rectangleRadius",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Circle") {
      enabledProps = [
        "radiusInput",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Ellipse") {
      enabledProps = [
        "radiusInputX",
        "radiusInputY",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Star") {
      enabledProps = [
        "outerRadius",
        "innerRadius",
        "pointsInput",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Arrow") {
      enabledProps = [
        "strokeWidth",
        "width",
        "pointerWidthInput",
        "pointerLengthInput",
        "filledInput",
      ];
    } else if (sel.getClassName() === "RegularPolygon") {
      enabledProps = [
        "radiusInput",
        "sidesInput",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Wedge") {
      enabledProps = [
        "radiusInput",
        "arcAngleInput",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Arc") {
      enabledProps = [
        "arcAngleInput",
        "outerRadius",
        "innerRadius",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "HeartShape") {
      enabledProps = [
        "width",
        "height",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "TeardropShape") {
      enabledProps = [
        "width",
        "height",
        "strokeWidth",
        "filledInput",
      ];
    } else if (sel.getClassName() === "Image" && (sel.attrs.group != "Tracks" && sel.attrs.type != "baseImage")) {
      enabledProps = [
        "scaleInput",
        //"rotationInput"       ,
      ];
    } else if (sel.getClassName() === "Track" && (sel.attrs.group == "Tracks")) {
      enabledProps = [
        "pegSizeSelect",
      ];
    } else if (sel.getClassName() === "MultiPathSVGGroup" && sel.attrs.group !== "Parts") {
      enabledProps = [
        "filledInput",
      ];
    }

    enabledProps.forEach((prop) => {
      //console.log("Enable prop", prop);
      propEls[prop] = true;
    });
    //console.log("propEls", propEls);

    Object.entries(propEls).forEach(([key, value]) => {
      //console.log(`${key}: ${value}`);
      try {
        if (!value) {
          document.getElementById(key).setAttribute("disabled", "");
          document.getElementById(key).parentNode.style.display = "none";
        } else {
          document.getElementById(key).removeAttribute("disabled");
          document.getElementById(key).parentNode.style.display = "block";
        }
      }
      catch (e) {
        console.log("Error Caught:", key, value);
        console.error(e);
      }
    });

    Object.entries(propEls).forEach(([key, value]) => {
      propVals[key] = "";
    });


    if (propEls.textString === true) {
      propVals.textString = sel.getText();
      propVals.fontFamily = sel.getFontFamily();
      propVals.fontStyle = sel.getFontStyle();
      propVals.fontSize = sel.getFontSize();
      propVals.letterSpacing = sel.getLetterSpacing();
    }

    if (sel.getClassName() && (sel.attrs.type === "sinewavetextpath")) {
      propVals.wavesInput = sel.waves();
      propVals.waveHeightInput = sel.amplitude();
      propVals.waveWidthInput = sel.frequency();
    }

    if (sel.getClassName() === "Text") {
      propVals.textDirection = sel.attrs.direction;
      propVals.align = sel.getAlign();
    }

    if (sel.getClassName() === "SidedTextPath") {
      propVals.sidesInput = sel.sides();
    }

    if (sel.getClassName() === "RectangleTextPath") {
      propVals.rectangleRadius = sel.rectangleRadius();
    }

    if (sel.getClassName() === "StarTextPath") {
      propVals.pointsInput = sel.points();
      propVals.radiusInput = sel.radius();
    }

    if (sel.getClassName() === "SpiralTextPath") {
      propVals.startRadiusInput = sel.startRadius();
      propVals.endRadiusInput = sel.endRadius();
      propVals.revolutionsInput = sel.revolutions();
    }

    if (sel.getClassName() === "SquareSpiralTextPath") {
      propVals.sizeInput = sel.size();
      propVals.turnsInput = sel.turns();
      propVals.spacingInput = sel.spacing();
      propVals.thicknessInput = sel.thickness();
    }


    if (sel.getClassName() === "Image") {
      propVals.scaleInput = parseInt(sel.getScaleX() * 100);
      //propVals.rotationInput     = parseInt(sel.getRotation());
    }


    // Shapes
    if (sel.getClassName() === "Rect") {
      propVals.rectangleRadius = sel.getCornerRadius();
      propVals.strokeWidth = sel.getStrokeWidth();
      propVals.filledInput = sel.getFill() != undefined ? true : false;
    }

    if (sel.getClassName() === "Circle") {
      propVals.radiusInput = sel.radius();
      propVals.strokeWidth = sel.getStrokeWidth();
      propVals.filledInput = sel.getFill() != undefined ? true : false;
    }

    if (sel.getClassName() === "Ellipse") {
      propVals.radiusInputX = sel.radiusX();
      propVals.radiusInputY = sel.radiusY();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "Star") {
      propVals.pointsInput = sel.getNumPoints();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "Arrow") {
      propVals.pointerWidthInput = sel.getPointerWidth();
      propVals.pointerLengthInput = sel.getPointerLength();
    }

    if (sel.getClassName() === "Wedge") {
      propVals.arcAngleInput = sel.getAngle();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "Arc") {
      propVals.arcAngleInput = sel.getAngle();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "RegularPolygon") {
      propVals.sidesInput = sel.getSides();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "HeartShape") {
      propVals.width = sel.getWidth();
      propVals.height = sel.getHeight();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "TeardropShape") {
      propVals.width = sel.getWidth();
      propVals.height = sel.getHeight();
      propVals.strokeWidth = sel.getStrokeWidth();
    }

    if (sel.getClassName() === "Track") {
      propVals.pegSizeSelect = getPegSizeFromScale(sel.scaleX());
    }

    if (sel.getClassName() === "MultiPathSVGGroup") {
      propVals.filledInput = sel.getFilled();
    }

    //console.log(propVals);
    Object.entries(propVals).forEach(([key, value]) => {
      if (key === "fontFamily") {
        app.fontChanger.selectOptionByFont(value);
      } else {
        if (document.getElementById(key).type != "checkbox") {
          document.getElementById(key).value = value;
        } else {
          document.getElementById(key).checked = value;
        }
      }
    });

  } else {
    Object.entries(propEls).forEach(([key, value]) => {
      try {
        document.getElementById(key).setAttribute("disabled", "");
        document.getElementById(key).parentNode.style.display = "none";
      }
      catch (e) {
        //console.log("Error Caught:", key, value);
        console.error(e);
      }
    });
  }

  app.updateBaseLayerDimensions(app.baseimagetransformer.size());
}




function moveItemPosition(direction, count) {
  let sel = app.getSelectedNode();

  if (sel) {
    switch (direction) {
      case "left":
        sel.setX(sel.getX() - count);
        break;
      case "right":
        sel.setX(sel.getX() + count);
        break;
      case "up":
        sel.setY(sel.getY() - count);
        break;
      case "down":
        sel.setY(sel.getY() + count);
        break;
    }
    app.getLayer().batchDraw();
  }
}

function processCountClick(event, fastEl) {
  let count = 1;
  if (event.shiftKey || fastEl.checked) {
    count = 10;
  }
  return count;
}

function processCountClickNegative(event, fastEl) {
  let count = -1;
  if (event.shiftKey || fastEl.checked) {
    count = -10;
  }
  return count;
}

addMultipleEventListener(document.getElementById('moveLeft'), "click touch", handleMoveLeftButtonClick);
function handleMoveLeftButtonClick(event) {
  moveItemPosition('left', processCountClick(event, document.getElementById('moveFast')));
}

addMultipleEventListener(document.getElementById('moveLeft'), "mousedown touchstart", handleMoveLeftButtonPress);
function handleMoveLeftButtonPress(event) {
  intervalId = setInterval(moveItemPosition, 100, 'left', processCountClick(event, document.getElementById('moveFast')));
}


addMultipleEventListener(document.getElementById('moveRight'), "click touch", handleMoveRightButtonClick);
function handleMoveRightButtonClick(event) {
  moveItemPosition('right', processCountClick(event, document.getElementById('moveFast')));
}

addMultipleEventListener(document.getElementById('moveRight'), "mousedown touchstart", handleMoveRightButtonPress);
function handleMoveRightButtonPress(event) {
  intervalId = setInterval(moveItemPosition, 100, 'right', processCountClick(event, document.getElementById('moveFast')));
}


addMultipleEventListener(document.getElementById('moveUp'), "click touch", handleMoveUpButtonClick);
function handleMoveUpButtonClick(event) {
  moveItemPosition('up', processCountClick(event, document.getElementById('moveFast')));
}

addMultipleEventListener(document.getElementById('moveUp'), "mousedown touchstart", handleMoveUpButtonPress);
function handleMoveUpButtonPress(event) {
  intervalId = setInterval(moveItemPosition, 100, 'up', processCountClick(event, document.getElementById('moveFast')));
}


addMultipleEventListener(document.getElementById('moveDown'), "click touch", handleMoveDownButtonClick);
function handleMoveDownButtonClick(event) {
  moveItemPosition('down', processCountClick(event, document.getElementById('moveFast')));
}

addMultipleEventListener(document.getElementById('moveDown'), "mousedown touchstart", handleMoveDownButtonPress);
function handleMoveDownButtonPress(event) {
  intervalId = setInterval(moveItemPosition, 100, 'down', processCountClick(event, document.getElementById('moveFast')));
}




function updateRadius(count) {
  let sel = app.getSelectedNode();

  if (sel) {
    sel.radius(sel.radius() + count);
  }
}

addMultipleEventListener(document.getElementById('radiusPlus'), "click touch", handleRadiusPlusButtonClick);
function handleRadiusPlusButtonClick(event) {
  updateRadius(processCountClick(event, document.getElementById('radiusFast')));
}

addMultipleEventListener(document.getElementById('radiusPlus'), "mousedown touchstart", handleRadiusPlusButtonPress);
function handleRadiusPlusButtonPress(event) {
  intervalId = setInterval(updateRadius, 100, processCountClick(event, document.getElementById('radiusFast')));
}

addMultipleEventListener(document.getElementById('radiusMinus'), "click touch", handleRadiusMinusButtonClick);
function handleRadiusMinusButtonClick(event) {
  updateRadius(processCountClickNegative(event, document.getElementById('radiusFast')));
}

addMultipleEventListener(document.getElementById('radiusMinus'), "mousedown touchstart", handleRadiusMinusButtonPress);
function handleRadiusMinusButtonPress(event) {
  intervalId = setInterval(updateRadius, 100, processCountClickNegative(event, document.getElementById('radiusFast')));
}




function updateRadiusX(count) {
  let sel = app.getSelectedNode();

  if (sel) {
    sel.radiusX(sel.radiusX() + count);
  }
}

addMultipleEventListener(document.getElementById('radiusPlusX'), "click touch", handleRadiusPlusXButtonClick);
function handleRadiusPlusXButtonClick(event) {
  updateRadiusX(processCountClick(event, document.getElementById('radiusXFast')));
}

addMultipleEventListener(document.getElementById('radiusPlusX'), "mousedown touchstart", handleRadiusPlusXButtonPress);
function handleRadiusPlusXButtonPress(event) {
  intervalId = setInterval(updateRadiusX, 100, processCountClick(event, document.getElementById('radiusXFast')));
}

addMultipleEventListener(document.getElementById('radiusMinusX'), "click touch", handleRadiusMinusXButtonClick);
function handleRadiusMinusXButtonClick(event) {
  updateRadiusX(processCountClickNegative(event, document.getElementById('radiusXFast')));
}

addMultipleEventListener(document.getElementById('radiusMinusX'), "mousedown touchstart", handleRadiusMinusXButtonPress);
function handleRadiusMinusXButtonPress(event) {
  intervalId = setInterval(updateRadiusX, 100, processCountClickNegative(event, document.getElementById('radiusXFast')));
}




function updateRadiusY(count) {
  let sel = app.getSelectedNode();

  if (sel) {
    sel.radiusY(sel.radiusY() + count);
  }
}

addMultipleEventListener(document.getElementById('radiusPlusY'), "click touch", handleRadiusPlusYButtonClick);
function handleRadiusPlusYButtonClick(event) {
  updateRadiusY(processCountClick(event, document.getElementById('radiusYFast')));
}

addMultipleEventListener(document.getElementById('radiusPlusY'), "mousedown touchstart", handleRadiusPlusYButtonPress);
function handleRadiusPlusYButtonPress(event) {
  intervalId = setInterval(updateRadiusY, 100, processCountClick(event, document.getElementById('radiusYFast')));
}

addMultipleEventListener(document.getElementById('radiusMinusY'), "click touch", handleRadiusMinusYButtonClick);
function handleRadiusMinusYButtonClick(event) {
  updateRadiusY(processCountClickNegative(event, document.getElementById('radiusYFast')));
}

addMultipleEventListener(document.getElementById('radiusMinusY'), "mousedown touchstart", handleRadiusMinusYButtonPress);
function handleRadiusMinusYButtonPress(event) {
  intervalId = setInterval(updateRadiusY, 100, processCountClickNegative(event, document.getElementById('radiusYFast')));
}




function updateOuterRadius(count) {
  let sel = app.getSelectedNode();

  if (sel) {
    sel.setOuterRadius(sel.getOuterRadius() + count);
    //app.getLayer().batchDraw();
  }
}

addMultipleEventListener(document.getElementById('outerRadiusPlus'), "click touch", handleOuterRadiusPlusButtonClick);
function handleOuterRadiusPlusButtonClick(event) {
  updateOuterRadius(processCountClick(event, document.getElementById('outerRadiusFast')));
}

addMultipleEventListener(document.getElementById('outerRadiusPlus'), "mousedown touchstart", handleOuterRadiusPlusButtonPress);
function handleOuterRadiusPlusButtonPress(event) {
  intervalId = setInterval(updateOuterRadius, 100, processCountClick(event, document.getElementById('outerRadiusFast')));
}

addMultipleEventListener(document.getElementById('outerRadiusMinus'), "click touch", handleOuterRadiusMinusButtonClick);
function handleOuterRadiusMinusButtonClick(event) {
  updateOuterRadius(processCountClickNegative(event, document.getElementById('outerRadiusFast')));
}

addMultipleEventListener(document.getElementById('outerRadiusMinus'), "mousedown touchstart", handleOuterRadiusMinusButtonPress);
function handleOuterRadiusMinusButtonPress(event) {
  intervalId = setInterval(updateOuterRadius, 100, processCountClickNegative(event, document.getElementById('outerRadiusFast')));
}




function updateInnerRadius(count) {
  let sel = app.getSelectedNode();

  if (sel) {
    sel.setInnerRadius(sel.getInnerRadius() + count);
    //app.getLayer().batchDraw();
  }
}

addMultipleEventListener(document.getElementById('innerRadiusPlus'), "click touch", handleInnerRadiusPlusButtonClick);
function handleInnerRadiusPlusButtonClick(event) {
  updateInnerRadius(processCountClick(event, document.getElementById('innerRadiusFast')));
}

addMultipleEventListener(document.getElementById('innerRadiusPlus'), "mousedown touchstart", handleInnerRadiusPlusButtonPress);
function handleInnerRadiusPlusButtonPress(event) {
  intervalId = setInterval(updateInnerRadius, 100, processCountClick(event, document.getElementById('innerRadiusFast')));
}

addMultipleEventListener(document.getElementById('innerRadiusMinus'), "click touch", handleInnerRadiusMinusButtonClick);
function handleInnerRadiusMinusButtonClick(event) {
  updateInnerRadius(processCountClickNegative(event, document.getElementById('innerRadiusFast')));
}

addMultipleEventListener(document.getElementById('innerRadiusMinus'), "mousedown touchstart", handleInnerRadiusMinusButtonPress);
function handleInnerRadiusMinusButtonPress(event) {
  intervalId = setInterval(updateInnerRadius, 100, processCountClickNegative(event, document.getElementById('innerRadiusFast')));
}




function updateRectangleWidth(count) {
  let sel = app.getSelectedNode();

  if (sel) {
    sel.rectangleWidth(sel.rectangleWidth() + count);
    //app.getLayer().batchDraw();
  }
}

addMultipleEventListener(document.getElementById('rectangleWidthPlus'), "click touch", handleRectangleWidthPlusButtonClick);
function handleRectangleWidthPlusButtonClick(event) {
  updateRectangleWidth(processCountClick(event, document.getElementById('rectangleWidthFast')));
}

addMultipleEventListener(document.getElementById('rectangleWidthPlus'), "mousedown touchstart", handleRectangleWidthPlusButtonPress);
function handleRectangleWidthPlusButtonPress(event) {
  intervalId = setInterval(updateRectangleWidth, 100, processCountClick(event, document.getElementById('rectangleWidthFast')));
}

addMultipleEventListener(document.getElementById('rectangleWidthMinus'), "click touch", handleRectangleWidthMinusButtonClick);
function handleRectangleWidthMinusButtonClick(event) {
  updateRectangleWidth(processCountClickNegative(event, document.getElementById('rectangleWidthFast')));
}

addMultipleEventListener(document.getElementById('rectangleWidthMinus'), "mousedown touchstart", handleRectangleWidthMinusButtonPress);
function handleRectangleWidthMinusButtonPress(event) {
  intervalId = setInterval(updateRectangleWidth, 100, processCountClickNegative(event, document.getElementById('rectangleWidthFast')));
}




function updateRectangleHeight(count) {
  let sel = app.getSelectedNode();

  if (sel) {
    sel.rectangleHeight(sel.rectangleHeight() + count);
    app.getLayer().batchDraw();
  }
}

addMultipleEventListener(document.getElementById('rectangleHeightPlus'), "click touch", handleRectangleHeightPlusButtonClick);
function handleRectangleHeightPlusButtonClick(event) {
  updateRectangleHeight(processCountClick(event, document.getElementById('rectangleHeightFast')));
}

addMultipleEventListener(document.getElementById('rectangleHeightPlus'), "mousedown touchstart", handleRectangleHeightPlusButtonPress);
function handleRectangleHeightPlusButtonPress(event) {
  intervalId = setInterval(updateRectangleHeight, 100, processCountClick(event, document.getElementById('rectangleHeightFast')));
}

addMultipleEventListener(document.getElementById('rectangleHeightMinus'), "click touch", handleRectangleHeightMinusButtonClick);
function handleRectangleHeightMinusButtonClick(event) {
  updateRectangleHeight(processCountClickNegative(event, document.getElementById('rectangleHeightFast')));
}

addMultipleEventListener(document.getElementById('rectangleHeightMinus'), "mousedown touchstart", handleRectangleHeightMinusButtonPress);
function handleRectangleHeightMinusButtonPress(event) {
  intervalId = setInterval(updateRectangleHeight, 100, processCountClickNegative(event, document.getElementById('rectangleHeightFast')));
}




function rectangleRadiusUpdated() {
  let radius = parseInt(document.getElementById("rectangleRadius").value);
  let sel = app.getSelectedNode();

  if (sel) {
    if (sel.getClassName() === "Rect") {
      sel.cornerRadius(radius);
    } else {
      sel.rectangleRadius(radius);
      app.getLayer().batchDraw();
    }
  }
}


function strokeWidthUpdated() {
  let strokeWidth = parseInt(document.getElementById("strokeWidth").value)
  let sel = app.getSelectedNode();

  if (sel) {
    sel.strokeWidth(strokeWidth);
  }
}


function filledUpdated() {
  let filled = document.getElementById("filledInput").checked;
  let sel = app.getSelectedNode();

  if (sel) {
    if (filled) {
      sel.fill(engraveColor);
    } else {
      sel.fill(transparentColor);
    }
  }
}


function pointerWidthUpdated() {
  let pointerWidth = parseInt(document.getElementById("pointerWidthInput").value)
  let sel = app.getSelectedNode();

  if (sel) {
    sel.pointerWidth(pointerWidth);
  }
}


function pointerLengthUpdated() {
  let pointerLength = parseInt(document.getElementById("pointerLengthInput").value)
  let sel = app.getSelectedNode();

  if (sel) {
    sel.pointerLength(pointerLength);
  }
}


function startRadiusUpdated() {
  let startRadius = parseInt(document.getElementById("startRadiusInput").value)
  let sel = app.getSelectedNode();

  if (sel) {
    sel.startRadius(startRadius);
  }
}


function endRadiusUpdated() {
  let endRadius = parseInt(document.getElementById("endRadiusInput").value)
  let sel = app.getSelectedNode();

  if (sel) {
    sel.endRadius(endRadius);
  }
}


function revolutionsUpdated() {
  let revolutions = parseInt(document.getElementById("revolutionsInput").value)
  let sel = app.getSelectedNode();

  if (sel) {
    sel.revolutions(revolutions);
  }
}


function updateWidth(count) {
  let sel = app.getSelectedNode();

  if (sel) {
    if (sel.getClassName() !== "Arrow") {
      sel.width(sel.width() + count);
    } else {
      sel.setPoints([0, 0, sel.getPoints()[2] + count, 0]);
    }
    //app.getLayer().batchDraw();
  }
}

addMultipleEventListener(document.getElementById('widthPlus'), "click touch", handleWidthPlusButtonClick);
function handleWidthPlusButtonClick(event) {
  updateWidth(processCountClick(event, document.getElementById('widthFast')));
}

addMultipleEventListener(document.getElementById('widthPlus'), "mousedown touchstart", handleWidthPlusButtonPress);
function handleWidthPlusButtonPress(event) {
  intervalId = setInterval(updateWidth, 100, processCountClick(event, document.getElementById('widthFast')));
}

addMultipleEventListener(document.getElementById('widthMinus'), "click touch", handleWidthMinusButtonClick);
function handleWidthMinusButtonClick(event) {
  updateWidth(processCountClickNegative(event, document.getElementById('widthFast')));
}

addMultipleEventListener(document.getElementById('widthMinus'), "mousedown touchstart", handleWidthMinusButtonPress);
function handleWidthMinusButtonPress(event) {
  intervalId = setInterval(updateWidth, 100, processCountClickNegative(event, document.getElementById('widthFast')));
}




function updateHeight(count) {
  let sel = app.getSelectedNode();

  if (sel) {
    sel.height(sel.height() + count);
    //app.getLayer().batchDraw();
  }
}
addMultipleEventListener(document.getElementById('heightPlus'), "click touch", handleHeightPlusButtonClick);
function handleHeightPlusButtonClick(event) {
  updateHeight(processCountClick(event, document.getElementById('heightFast')));
}

addMultipleEventListener(document.getElementById('heightPlus'), "mousedown touchstart", handleHeightPlusButtonPress);
function handleHeightPlusButtonPress(event) {
  intervalId = setInterval(updateHeight, 100, processCountClick(event, document.getElementById('heightFast')));
}

addMultipleEventListener(document.getElementById('heightMinus'), "click touch", handleHeightMinusButtonClick);
function handleHeightMinusButtonClick(event) {
  updateHeight(processCountClickNegative(event, document.getElementById('heightFast')));
}

addMultipleEventListener(document.getElementById('heightMinus'), "mousedown touchstart", handleHeightMinusButtonPress);
function handleHeightMinusButtonPress(event) {
  intervalId = setInterval(updateHeight, 100, processCountClickNegative(event, document.getElementById('heightFast')));
}




function sidesUpdated() {
  let sel = app.getSelectedNode();

  if (sel && (sel.getClassName() === "SidedTextPath" || sel.getClassName() === "RegularPolygon")) {
    let sides = parseInt(document.getElementById("sidesInput").value);
    if (sides < 3) {
      sides = 3;
      document.getElementById("sidesInput").value = 3;
    }
    if (sides > 12) {
      sides = 12;
      document.getElementById("sidesInput").value = 12;
    }
    sel.sides(sides);
    app.getLayer().batchDraw();
  }
}


function pointsUpdated() {
  let sel = app.getSelectedNode();

  if (sel && (app.getSelectedNode().getClassName() === "StarTextPath" || app.getSelectedNode().getClassName() === "Star")) {
    let points = parseInt(document.getElementById("pointsInput").value);

    if (points < 2) {
      points = 2;
      document.getElementById("pointsInput").value = 2;
    }
    if (points > 12) {
      points = 12;
      document.getElementById("pointsInput").value = 12;
    }

    if (app.getSelectedNode().getClassName() === "StarTextPath") {
      sel.points(points);
    } else {
      sel.setNumPoints(points);
    }
    app.getLayer().batchDraw();
  }
}


function pegSizeUpdated(size) {
  let ps = pegSizes.find(p => p.name === size);

  if (ps && ps.scale) {
    app.getSelectedNode().scale({ x: ps.scale, y: ps.scale });
  }
}


function getPegSizeFromScale(scale) {
  let ret = "";

  pegSizes.forEach(p => {
    if (p.scale === scale) {
      ret = p.name;
    }
  });

  return ret;
}


function sizeUpdated() {
  let size = parseInt(document.getElementById('sizeInput').value);
  //console.log("sizeUpdated", turns);
  app.getSelectedNode().size(size);
}


function turnsUpdated() {
  let turns = parseInt(document.getElementById('turnsInput').value);
  //console.log("turnsUpdated", turns);
  app.getSelectedNode().turns(turns);
}


function spacingUpdated() {
  let spacing = parseInt(document.getElementById('spacingInput').value);
  //console.log("spacingUpdated", spacing);
  app.getSelectedNode().spacing(spacing);
}


function thicknessUpdated() {
  let thickness = parseInt(document.getElementById('thicknessInput').value);
  //console.log("thicknessUpdated", thickness);
  app.getSelectedNode().thickness(thickness);
}


function wavesInputUpdated() {
  let waves = parseInt(document.getElementById("wavesInput").value);
  let amplitude = parseInt(document.getElementById("waveHeightInput").value);
  let frequency = parseInt(document.getElementById("waveWidthInput").value);

  if (app.getSelectedNode().className === "SinewaveTextPath") {
    app.getSelectedNode().waves(waves);
    app.getSelectedNode().amplitude(amplitude);
    app.getSelectedNode().frequency(frequency);
    app.getSelectedNode().updatePath();
    app.getLayer().batchDraw();
  }
}


function textStringUpdated(e) {
  let sel = app.getSelectedNode();

  if (sel) {
    sel.setText(document.getElementById("textString").value);
    transformer.forceUpdate();

    if (sel.className === "TextPath") {
      //console.log("textPath text string changed", sel.fontSize());
      if (sel.attrs.type === "curvedtextpath") {
        sel.setData(describeArc(400, 400, sel.fontSize() * 6, sel.attrs.angle, 0));
      } else if (sel.attrs.type === "sinewavetextpath") {
        sel.setData(createSinewaveTextPath(sel.attrs.amplitude, sel.attrs.frequency, sel.attrs.waves));
      } else if (sel.attrs.type === "ellipsetextpath") {
        sel.setData(generateEllipseSvgTextPath(400, 400, 200, 120, 0));
      } else if (sel.attrs.type === "circletextpath") {
        sel.setData(generateCircleSvgTextPath(400, 400, 200));
      }
    }
  }
}


function arcAngleRangeUpdated(e) {
  let sel = app.getSelectedNode();
  if (sel && sel.className === "TextPath") {
    document.getElementById("arcAngleInput").value =
      document.getElementById("arcAngleRange").value;
    sel.data(
      describeArc(
        400,
        400,
        100,
        document.getElementById("arcAngleRange").value,
        0
      )
    );
    transformer.forceUpdate();
    sel.attrs.angle = parseInt(document.getElementById("arcAngleRange").value);
  }
}


function arcAngleInputUpdated(e) {
  let sel = app.getSelectedNode();

  if (sel && (sel.className === "Wedge" || sel.className === "Arc")) {
    let angle = parseInt(document.getElementById("arcAngleInput").value);
    sel.setAngle(angle);
  }

  if (sel && sel.className === "TextPath") {
    document.getElementById("arcAngleRange").value = document.getElementById("arcAngleInput").value;
    sel.data(
      describeArc(
        400,
        400,
        100,
        document.getElementById("arcAngleInput").value,
        0
      )
    );
    transformer.forceUpdate();
    sel.attrs.angle = parseInt(document.getElementById("arcAngleInput").value);
  }
}


function fontSizeUpdated(e) {
  let sel = app.getSelectedNode();
  if (sel) {
    sel.setFontSize(parseInt(document.getElementById("fontSize").value));
    transformer.forceUpdate();

    /*
    if (sel.className === "TextPath") {
      //console.log("textPath font size changed", sel.fontSize());

      if (sel.attrs.type === "curvedtextpath") {
        sel.setData(describeArc(400, 400, sel.fontSize() * 6, sel.attrs.angle, 0));
      } else if (sel.attrs.type === "sinewavetextpath") {
        sel.setData(createSinewaveTextPath(sel.attrs.amplitude, sel.attrs.frequency, sel.attrs.waves)) ;
      }
    }
    */
  }
}


function fontStyleUpdated(e) {
  let sel = app.getSelectedNode();
  if (sel) {
    sel.setFontStyle(document.getElementById("fontStyle").value);
    transformer.forceUpdate();

    /*
    if (sel.className === "TextPath") {
      //console.log("textPath font size changed", sel.fontSize());

      if (sel.attrs.type === "curvedtextpath") {
        sel.setData(describeArc(400, 400, sel.fontSize() * 6, sel.attrs.angle, 0));
      } else if (sel.attrs.type === "sinewavetextpath") {
        sel.setData(createSinewaveTextPath(sel.attrs.amplitude, sel.attrs.frequency, sel.attrs.waves)) ;
      }
    }
    */
  }
}


function letterSpacingUpdated(e) {
  let sel = app.getSelectedNode();
  if (sel) {
    sel.setLetterSpacing(parseInt(document.getElementById("letterSpacing").value));
    transformer.forceUpdate();
  }
}


function lineHeightUpdated(e) {
  let sel = app.getSelectedNode();
  if (sel) {
    sel.lineHeight(parseFloat(document.getElementById("lineHeightInput").value));
    transformer.forceUpdate();
  }
}


function scaleInputUpdated(e) {
  let sel = app.getSelectedNode();
  if (sel) {
    let scale = parseFloat(
      parseInt(document.getElementById("scaleInput").value) / 100
    );
    sel.scale({ x: scale, y: scale });
    transformer.forceUpdate();
  }
}


function rotationInputUpdated(e) {
  return;

  let sel = app.getSelectedNode();
  if (sel) {
    let rot = parseInt(document.getElementById("rotationInput").value);
    //sel.setRotation(rot);
    transformer.setRotation(rot);
    transformer.forceUpdate();
  }
}




